var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:_vm.buttonClass,on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.iconStart)?_c('icon',{attrs:{"name":_vm.iconStart}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"new-button__text"},[_vm._v(_vm._s(_vm.text))]),_vm._v(" "),(_vm.iconEnd)?_c('icon',{attrs:{"name":_vm.iconEnd}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }